module.exports = __webpack_public_path__ + "img/UTQUAI-5.28b8dd43.jpg";